import React, { useState } from 'react'

import { AddAPhoto } from '@material-ui/icons'
import { useTheme } from '@material-ui/core/styles'

import { Container } from '../Container'
import { Issue, InventoryInspection } from '../../models/Inspection'
import { typographyStyle } from '../../theme/typographyStyle'

interface IssueImageProps {
    index: number
    issue: Issue
    inventoryInspection: InventoryInspection
    onImageUpdate?: (issueId: number, responseData: any) => void
    addImageToIssue?: (issueId: number, file: File) => Promise<any>
}

export const IssueImage: React.FC<IssueImageProps> = ({
    index,
    issue,
    onImageUpdate,
    addImageToIssue,
}) => {
    const theme = useTheme()
    const [isUploading, setIsUploading] = useState(false)

    const handleImageUpload = async (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const file = event.target.files?.[0]
        if (!file || !addImageToIssue) return

        setIsUploading(true)

        try {
            const response = await addImageToIssue(issue.id, file)
            onImageUpdate?.(issue.id, response)
        } catch (error) {
            console.error('Error uploading image:', error)
        } finally {
            setIsUploading(false)
        }
    }

    // Only show this component if there's no existing image at this index
    const existingImage = issue.message.attachments[index]

    if (existingImage) {
        return null // Don't render anything if there's already an image at this index
    }

    return (
        <Container
            style={{
                width: 90,
                height: 90,
                border: `2px dashed ${theme.palette.grey[400]}`,
                borderRadius: theme.shape.borderRadius,
                margin: theme.spacing(0, 0.5),
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                overflow: 'hidden',
            }}
        >
            <Container
                style={{
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                    id={`issue-image-${issue.id}-${index}`}
                    disabled={isUploading}
                />
                <label htmlFor={`issue-image-${issue.id}-${index}`}>
                    <AddAPhoto
                        style={{
                            color: theme.palette.grey[500],
                            fontSize: 32,
                            cursor: 'pointer',
                        }}
                    />
                </label>
                {isUploading && (
                    <span
                        style={{
                            ...typographyStyle(theme.typography.caption),
                            color: theme.palette.grey[500],
                            marginTop: theme.spacing(0.5),
                        }}
                    >
                        Uploading...
                    </span>
                )}
            </Container>
        </Container>
    )
}
